import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromoNotificationsModelType } from 'src/api/config/promo_notifications/get_promo_notifications';
import { NotificationPageImageForm } from './NotificationPageForm/NotificationPageImageForm';
import { NotificationPageVideoForm } from './NotificationPageForm/NotificationPageVideoForm';
import { NotificationPageListItem } from './NotificationPageListItem/NotificationPageListItem';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const NotificationPage = observer(() => {
    const { notificationPageState } = useAppStateContext();
    const { isLoading, notificationPagesSorted, selectedNotificationPageType} = notificationPageState;

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={isLoading}>
                        <Loader isActive={isLoading}/>
                        {notificationPagesSorted !== null && notificationPagesSorted.map((notificationPage: PromoNotificationsModelType | null) => {
                            return (notificationPage !== null && notificationPage.id) ? <NotificationPageListItem key={notificationPage?.id} notificationPage={notificationPage} /> : null;
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    {selectedNotificationPageType === 'image' ? <NotificationPageImageForm /> : <NotificationPageVideoForm />}
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
